import React, { PureComponent } from 'react';
import '../../../config/import';
import './App.css';
var Tesseract = window.Tesseract;

export default class Home extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            uploads: [],
            uploadsPdf: [],
            patterns: [],
            documents: []
        };
    }

    handleChange = (event) => {
        if (event.target.files[0]) {
            var uploads = []
            for (var key in event.target.files) {
                if (!event.target.files.hasOwnProperty(key)) continue;
                let upload = event.target.files[key]
                uploads.push(URL.createObjectURL(upload))
            }
            this.setState({
                uploads: uploads
            })
        } else {
            this.setState({
                uploads: []
            })
        }
    }

    generateText = () => {
        let uploads = this.state.uploads;

        for (var i = 0; i < uploads.length; i++) {
            
            Tesseract.recognize(uploads[i], {
                lang: 'eng'
            })
                .catch(err => {
                    console.error(err)
                })
                .then(result => {
                    // Get Confidence score
                    let confidence = result.confidence

                    // Get full output
                    let text = result.text

                    // Get codes
                    let pattern = /\b\w{10,10}\b/g
                    let patterns = result.text.match(pattern);

                    // Update state
                    this.setState({
                        patterns: this.state.patterns.concat(patterns),
                        documents: this.state.documents.concat({
                            pattern: patterns,
                            text: text,
                            confidence: confidence
                        })
                    })
                })
        }
    }

    render() {
        return (
            <div className="app">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <header className="header">
                    <br />
                    <br />
                    <br />
                    <h1>Tesseract</h1>
                </header>

                { /* File uploader */}
                <section className="hero">
                    <label className="fileUploaderContainer">
                        Click here to upload documents
            <input type="file" id="fileUploader" onChange={this.handleChange} multiple />
                    </label>

                    <div>
                        {this.state.uploads.map((value, index) => {
                            return <img key={index} src={value} width="100px" />
                        })
                        }
                    </div>

                    <button onClick={this.generateText} className="button">Generate</button>
                </section>

                { /* Results */}
                <section className="results">

                    <div className="results__result">
                        <div className="results__result__image">
                            <img width="250px" />
                        </div>
                        <div className="results__result__info">
                            <div className="results__result__info__codes">
                                <small>{ /* Confidence score */}</small>
                            </div>
                            <div className="results__result__info__codes">
                                <small>{ /* Pattern output */}</small>
                            </div>
                            <div className="results__result__info__text">
                                <small>{ /* Full output */}</small>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <div className="results__result">
                        { /* Additional output if more than one document is processed */}
                        {
                            this.state.documents.map((value, index) => {
                                return (
                                    <div key={index} className="results__result">
                                        <div className="results__result__image">
                                            <img src={this.state.uploads[index]} width="250px" />
                                        </div>
                                        <div className="results__result__info">
                                            <div className="results__result__info__codes">
                                                <small><strong>Confidence Score:</strong> {value.confidence}</small>
                                            </div>
                                            <div className="results__result__info__text">
                                                <small><strong>Full Output:</strong> {value.text}</small>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>

                </section>
            </div>
        );
    }
}